import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20modern%20Japanese%20data%20center%20server%20room%20with%20dark%20ambient%20lighting%20and%20cool%20blue%20LED%20indicator%20lights%20on%20racks%2C%20reflective%20black%20floor%2C%20clean%20minimal%20layout%2C%20high-end%20corporate%20atmosphere%2C%20depth%20of%20field%2C%20cinematic%20mood%2C%20no%20people%2C%20technology%20infrastructure%20aesthetic&width=1600&height=900&seq=hero-datacenter-2026&orientation=landscape"
        alt="データセンター サーバールーム"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24 px-6 md:px-12 lg:px-20">
        <div className="max-w-[1280px] mx-auto w-full">
          {/* Tag */}
          <div className="inline-block px-4 py-1.5 rounded-full border border-white/30 mb-6">
            <span className="text-white/90 text-xs md:text-sm tracking-[0.2em] font-sans font-light">信頼と革新</span>
          </div>

          {/* Main Title */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-light text-white tracking-[0.06em] leading-[1.3] max-w-2xl">
            金融の未来を、
            <br />
            データで守る。
          </h1>

          {/* Subtitle */}
          <p className="mt-5 md:mt-7 text-sm md:text-base text-white/70 tracking-[0.08em] font-sans font-light max-w-xl leading-relaxed">
            AIとビッグデータ分析で、カード決済の不正をリアルタイムに検知。
            <br className="hidden md:block" />
            金融機関のセキュリティを、次世代のテクノロジーで支えます。
          </p>

          {/* CTA */}
          <div className="mt-7 md:mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-primary-900 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              事業紹介
              <i className="ri-arrow-right-line text-base" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/40 text-white text-sm md:text-base tracking-[0.08em] font-sans font-light hover:bg-white/10 hover:border-white/60 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              お問合わせ
              <i className="ri-mail-line text-base" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}